/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Video_File_HelpInputs */



/**
* | output |
* | --- |
* | "Select a video file to export with AD" |
*
* @param {Audio_Description_Export_Video_File_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_video_file_help = /** @type {((inputs?: Audio_Description_Export_Video_File_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Video_File_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un fichier vidéo à exporter avec l'AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Videodatei aus, die mit AD exportiert werden soll.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un file video da esportare con AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите видеофайл для экспорта с помощью AD.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un archivo de vídeo para exportar con AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要使用 AD 导出的视频文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADでエクスポートするビデオファイルを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD के साथ निर्यात करने के लिए एक वीडियो फ़ाइल चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um arquivo de vídeo para exportar com o AD.")
	return /** @type {LocalizedString} */ ("Select a video file to export with AD")
});